import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useGlobalModalContext from '../../hooks/useGlobalModalContext';
import { useProgressContext } from '../../preorder/contexts/useProgressContext';
import { authActionType, useAuthDispatch } from '../../preorder/plugins/Auth';
import {
  getUserProfile, sendVerifyCode, phoneAuth, register,
} from '../api/auth';
import Register from '../components/Register';

const ConnectPhone = () => {
  const {
    start: startProgress,
    end: endProgress,
  } = useProgressContext();
  const authDispatch = useAuthDispatch();
  const history = useHistory();
  const location = useLocation();
  const { openModal } = useGlobalModalContext();
  const { state } = location || {};
  const {
    afterLoginUrl, token: thirdPartyAuthToken, from, providerId,
  } = state || {};
  const [phoneAuthToken, setPhoneAuthToken] = useState('');

  useEffect(() => {
    if (!thirdPartyAuthToken) history.push('/');
  }, [history, thirdPartyAuthToken]);

  const onNextButtonClick = useCallback(
    async (phoneNumber) => {
      try {
        startProgress();

        const result = await sendVerifyCode(phoneNumber);

        const { status, message } = result || {};

        if (status !== 'success') throw new Error(message || 'send verifyCode fail');

        endProgress();

        return true;
      } catch (e) {
        const { message } = e;

        openModal({
          title: '發送驗證碼失敗',
          content: message || '發送驗證碼失敗，請連繫客服人員',
        });

        endProgress();

        return false;
      }
    }, [startProgress, endProgress, openModal]
  );

  const onAuthButtonClick = useCallback(async (phoneNumber, verifyCode) => {
    try {
      startProgress();

      const {
        status: phoneAuthStatus,
        data: phoneAuthData,
        message: phoneAuthMessage,
      } = await phoneAuth(phoneNumber, verifyCode);

      if (phoneAuthStatus !== 'success') throw new Error(phoneAuthMessage);

      const { token: dataPhoneAuthToken } = phoneAuthData;

      if (!dataPhoneAuthToken) throw new Error('電話驗證失敗');

      setPhoneAuthToken(dataPhoneAuthToken);

      endProgress();

      return true;
    } catch (e) {
      const { message } = e;

      openModal({
        title: message || '登入失敗',
        content: message || '登入失敗，請連繫客服人員',
      });

      endProgress();

      return false;
    }
  }, [
    endProgress,
    openModal,
    startProgress,
  ]);

  const onProfileNextButtonClick = async (value) => {
    try {
      startProgress();

      const {
        day, month, year, gender, email,
      } = value || {};
      const {
        status: registerStatus,
        data: registerData,
        message: registerMessage,
      } = await register(
        phoneAuthToken,
        thirdPartyAuthToken,
        undefined,
        undefined,
        from,
        [year, month, day],
        gender,
        email,
        providerId
      );

      if (registerStatus !== 'success') throw new Error(registerMessage);

      const { token: registerAuthToken } = registerData;

      if (!registerAuthToken) throw new Error('註冊失敗');

      const userProfileReseult = await getUserProfile(registerAuthToken);
      const {
        data: profile,
        status: getUserProfileStatus,
        message: getUserProfileMessage,
      } = userProfileReseult || {};

      if (getUserProfileStatus !== 'success') throw new Error(getUserProfileMessage);

      authDispatch({
        type: authActionType.LOGIN_SUCCESS,
        payload: {
          token: registerAuthToken,
          user: {
            ...profile,
          },
        },
      });

      endProgress();
    } catch (e) {
      const { message } = e;

      openModal({
        title: message || '登入失敗',
        content: message || '登入失敗，請連繫客服人員',
      });

      endProgress();
    }
  };

  return (
    <Register
      afterLoginUrl={afterLoginUrl}
      isConnectPhone
      onNextButtonClick={onNextButtonClick}
      onAuthButtonClick={onAuthButtonClick}
      onProfileNextButtonClick={onProfileNextButtonClick}
    />
  );
};

export default ConnectPhone;
